import { JsonObject } from 'json2typescript';
import CartItem from './CartItem';
import CartItemRank from './CartItemRank';

@JsonObject('Cart')
export default class Cart {
  constructor() {
    this.cartCode = '';
    this.totalFee = 0;
    this.discount = 0;
    this.cartItems = new Array<CartItem>();
  }

  public cartCodeOrg: string;

  public cartCode: string;

  public totalFee: number;

  public discount: number;

  public cartItems: Array<CartItem>;

  public get canBuy(): boolean {
    return this.cartItems.find((v) => !v.canBuy) === undefined;
  }

  public get totalQuantity(): number {
    const t = this.cartItems.reduce((c, v) => {
      // eslint-disable-next-line no-param-reassign
      c.quantity += v.quantity;
      return c;
    }, new CartItemRank());
    return t.quantity;
  }
}
